import Vue from 'vue'


/**
* Retries the given request
*
* @param request
* @return Promise
*/
export function retry(request) {
    if (request == null) {
        return
    }

    const method = request.method.toLowerCase();
    const opts = {
        retry: (request.retry || 10 ) - 1, // counts down
        params: request.params,
    }

    console.log('RETRY', request.url, request.body, opts);

    if ( ['post', 'put', 'patch'].includes(method) ) {
        return Vue.http[method](request.url, request.body, opts);
    }

    return Vue.http[method](request.url, opts);
}



// WEBPACK FOOTER //
// ./resources/assets/js/api/helpers.js